import { HttpHeaders } from '@angular/common/http/src/headers';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Mhsrcuser } from '../models/user';
import { environment } from '../../environments/environment';

@Injectable()
export class InstructorService {

  private _instructorUrl: string = `${environment.apiRootURL}/instructors`;

  constructor(private _http: Http) { }

  getInstructorByEmail(email: string) {
    const aurl = `${this._instructorUrl}/GetInstructorByEmail/${email}`;
    console.log('HTTP GET ' + aurl); 
    return this._http.get(aurl).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/instructor.service.ts